import { type IPageTwoColumns } from "@contentful-api/types/contentful";
import { PageTypes } from "@lib/enums/PageTypes";

export const isTwoColumnPage = (page: any): page is IPageTwoColumns => {
    return page?.sys?.contentType?.sys?.id === PageTypes.TWO_COLUMNS;
};
